import { client } from './client';

// --- Auth ---

export const csrfCookie = async () => {
    await client.get('/v1/csrf-token');
};

export const login = async ({ email, password, remember = false }) => {
    const response = await client.post('/v1/auth/login', {
        email,
        password,
        remember,
    });
    return response.data;
};

export const register = async ({ name, email, password, passwordConfirmation, inviteCode }) => {
    await client.post('/v1/user', {
        name,
        email,
        password,
        password_confirmation: passwordConfirmation,
        invite_code: inviteCode,
    });
    // Returns 204 — session established automatically
};

export const logout = async () => {
    await client.post('/v1/auth/logout');
};

export const forgotPassword = async (email) => {
    const response = await client.post('/v1/auth/forgot-password', { email });
    return response.data;
};

export const resetPassword = async ({ token, email, password, password_confirmation }) => {
    const response = await client.post('/v1/auth/reset-password', {
        token,
        email,
        password,
        password_confirmation,
    });
    return response.data;
};

export const resendVerificationEmail = async () => {
    const response = await client.post('/v1/auth/email/verification-notification');
    return response.data;
};

export const user = async () => {
    try {
        const response = await client.get('/v1/user', { _skipAuthRedirect: true });
        return response.data;
    } catch (error) {
        if (error.status === 401 || error.status === 404) {
            return null;
        }
        console.error('Unexpected error', error);
        return null;
    }
};
